import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.css']
})
export class PublicProfileComponent implements OnInit {
  corperSlug: string | null = null

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.corperSlug = this.route.snapshot.paramMap.get('route-id')
  }
}
